/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsMFADisabledUser
 */
export interface JumboStructsMFADisabledUser {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMFADisabledUser
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMFADisabledUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMFADisabledUser
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMFADisabledUser
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JumboStructsMFADisabledUser
     */
    isMFAEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMFADisabledUser
     */
    surname?: string;
}

/**
 * Check if a given object implements the JumboStructsMFADisabledUser interface.
 */
export function instanceOfJumboStructsMFADisabledUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsMFADisabledUserFromJSON(json: any): JumboStructsMFADisabledUser {
    return JumboStructsMFADisabledUserFromJSONTyped(json, false);
}

export function JumboStructsMFADisabledUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsMFADisabledUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isMFAEnabled': !exists(json, 'isMFAEnabled') ? undefined : json['isMFAEnabled'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
    };
}

export function JumboStructsMFADisabledUserToJSON(value?: JumboStructsMFADisabledUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'email': value.email,
        'givenName': value.givenName,
        'id': value.id,
        'isMFAEnabled': value.isMFAEnabled,
        'surname': value.surname,
    };
}

